import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';

export const helpLegendAnimations = [
  trigger('helpLegendToggler', [
    state('inactive', style({
      transform: 'rotate(0deg)',
    })),
    state('active', style({
      transform: 'rotate(360deg)',
    })),
    transition('* <=> *', animate('500ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
  ]),
  trigger('helpLegendContainer', [
    state('inactive', style({ height: '0px', borderWidth: '0px' })),
    state('active', style({ height: '*', borderWidth: '1px' })),
    transition('active <=> inactive', animate('500ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
  ]),
];
